module.exports = "/assets/data/bb94a7857867a04d5f23e8a8a4b920cc-L11.data.json";